import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
} from '@chakra-ui/react';
import { useRef } from 'react';

type IntegrationToggleAction = 'deactivate' | 'reactivate' | null;

interface IntegrationToggleConfirmDialogProps {
  isOpen: boolean;
  action: IntegrationToggleAction;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function IntegrationToggleConfirmDialog({
  isOpen,
  action,
  isLoading,
  onCancel,
  onConfirm,
}: IntegrationToggleConfirmDialogProps) {
  const cancelRef = useRef<HTMLButtonElement | null>(null);

  const isDeactivating = action === 'deactivate';

  return (
    <AlertDialog
      isOpen={isOpen && !!action}
      leastDestructiveRef={cancelRef}
      onClose={onCancel}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {isDeactivating
              ? 'Deactivate All Integrations'
              : 'Reactivate Integrations'}
          </AlertDialogHeader>

          <AlertDialogBody>
            {isDeactivating ? (
              <Text>
                Are you sure you want to deactivate all active integrations for
                this organization? This action cannot be undone.
              </Text>
            ) : (
              <Text>
                Are you sure you want to reactivate integrations for this
                organization?
              </Text>
            )}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onCancel} isDisabled={isLoading}>
              Cancel
            </Button>
            <Button
              colorScheme={isDeactivating ? 'red' : 'green'}
              onClick={onConfirm}
              isLoading={isLoading}
              ml={3}
            >
              {isDeactivating ? 'Deactivate' : 'Reactivate'}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
